import { applicationConfiguration } from '@/api/abp'
const state = {
  abpConfig: null,
  active:0,
}

const mutations = {
  SET_ABPCONFIG: (state, abpConfig) => {
    state.abpConfig = abpConfig
  },
  SET_ACTIVE:(state,active)=>{
    state.active = active;
  }
}

const actions = {
  applicationConfiguration({ commit }) {
    return new Promise((resolve, reject) => {
      applicationConfiguration()
        .then(response => {
          commit('SET_ABPCONFIG', response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setActive({commit},value){
    commit('SET_ACTIVE',value);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
